import type { FireworkCue } from "../rendering/celebration/fireworkScore";

export const FIREWORK_VOICE_LIMIT = 8;

/** Keep close volleys spacious rather than multiplying their loudness. */
export function getFireworkVoiceGain(cue: FireworkCue, activeVoices: number) {
  const overlap = Math.max(0, activeVoices);
  const headroom = 1 / Math.sqrt(1 + overlap * 0.32);
  return cue.power * (1 - Math.abs(cue.z) * 0.12) * headroom;
}
